import { formatViewerDate } from '@/viewer-locale/application/viewerLocaleFormatters';
import { getViewerLocale } from '@/viewer-locale/application/viewerLocaleStore';
import type { ViewerLocale } from '@/viewer-locale/domain/ViewerLocale';

/**
 * "v3" — the live version number, and nothing else.
 *
 * A version string never carries a "(draft)" suffix: draftness is a lifecycle fact and
 * belongs to the STATUS lozenge, not the version. Blocks have no Draft status by product
 * decision (a block's v1 stays live while v2 is edited), so on a block card there is
 * nothing extra to show; where a record genuinely can be a draft (templates), the status
 * already says so (design ruling 2026-09-07).
 */
export function formatVersion(versionNumber: number): string {
  return versionNumber > 0 ? `v${versionNumber}` : '';
}

/**
 * "Edited" date for a library card, in the viewer's preferred order and time zone
 * (LLAMS-469/476). The prototype hard-coded a US month-day-year date-fns pattern here
 * directly; that inline pattern is exactly what the `viewer-locale/no-hardcoded-date-pattern`
 * ESLint rule (and this repo's `noHardcodedAuthoringDatePatterns` regression test) forbid, so
 * formatting is delegated to the sanctioned `formatViewerDate` helper instead.
 */
export function formatLastEdited(iso: string | null | undefined, locale: ViewerLocale = getViewerLocale()): string {
  if (!iso) return '';
  return formatViewerDate(iso, locale);
}
